import React from 'react'
import "../styles/feature.css"

function Features() {

  const features = [
    {
      title: "Real time insights",
      desc: "Get instant visibility into machine performance with live, accurate operational data.",
      icon: "fa fa-hourglass",
    },
    {
      title: "Efficiency optimisation",
      desc: "Identify bottlenecks and boost productivity using data-driven performance analytics.",
      icon: "fa fa-dashboard",
    },
    {
      title: "Production Tracking",
      desc: " Monitor output effortlessly with automated tracking of every unit produced",
      icon: "fa fa-bar-chart",
    },
    {
      title: "Scalable Compute Layer",
      desc: "Handle growing data and operations seamlessly with our high-performance, cloud-ready architecture.",
      icon: "fa fa-database",
    },
  ];

  return (
    <div className='feature-container'>
      <div className='feature-block'>
        <button className="feature-tag">Features</button>
      </div>
      <h1 className='feature-heading'>
        Core Capabilities That <br></br>
        Drive Smarter Enterprise
      </h1>
      <br></br>
      <br></br>

      <div className='feature-card-container'>
        <div className='leftBlock'>
          <div className='card-big'>
            <h3>{features[0].title}</h3>
            <span>{features[0].desc}</span>
            <div className='main-icon'>
              <i class={features[0].icon}></i>
            </div>
          </div>
          <div className='card-samll'>
            <div className='main-icon'>
              <i class={features[1].icon}></i></div>
            <div>
              <h3>{features[1].title}</h3>
              <span>{features[1].desc}</span>
            </div>
          </div>
        </div>
        <div className='rightBlock'>
          <div className='card-samll'>
            <div className='main-icon'>
              <i class={features[2].icon}></i>
            </div>
            <div>
              <h3>{features[2].title}</h3>
              <span>{features[2].desc}</span>
            </div>
          </div>
          <div className='card-big'>
            <h3>{features[3].title}</h3>
            <span>{features[3].desc}</span>
            <div className='main-icon'>
              <i class={features[3].icon}></i>
            </div>
          </div>
        </div>

      </div>

    </div>
  )
}

export default Features